"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateEvaluatorFiltersForTarget = validateEvaluatorFiltersForTarget;
const filters_1 = require("../../interfaces/filters");
const tracesTable_1 = require("../../tableDefinitions/tracesTable");
const observationForEval_1 = require("./observationForEval");
const filterTypeCompatibility_1 = require("../../server/queries/clickhouse-sql/filterTypeCompatibility");
const types_1 = require("./types");
const parsedFilterSchema = filters_1.singleFilterList.nullable();
const getSupportedColumnsForTarget = (targetObject) => {
    switch (targetObject) {
        case types_1.EvalTargetObject.TRACE:
            return tracesTable_1.evalTraceTableCols;
        case types_1.EvalTargetObject.DATASET:
            return tracesTable_1.evalDatasetFormFilterCols;
        case types_1.EvalTargetObject.EVENT:
            return observationForEval_1.eventsEvalFilterColumns;
        case types_1.EvalTargetObject.EXPERIMENT:
            return observationForEval_1.experimentEvalFilterColumns;
    }
};
const findMatchingColumnDefinition = (filterColumn, columns) => columns.find((column) => column.id === filterColumn ||
    column.name === filterColumn ||
    column.aliases?.includes(filterColumn));
function validateEvaluatorFiltersForTarget(params) {
    const columns = getSupportedColumnsForTarget(params.targetObject);
    const parsedFilter = parsedFilterSchema.safeParse(params.filter);
    if (!parsedFilter.success) {
        return {
            isValid: false,
            validatedFilters: [],
            issues: [
                {
                    code: "invalid_filter_shape",
                    message: "Evaluator filters are invalid. Remove unsupported or incomplete filters and try again.",
                    index: null,
                    column: null,
                    filterType: null,
                },
            ],
        };
    }
    const filters = parsedFilter.data ?? [];
    const issues = filters.flatMap((filter, index) => {
        const column = findMatchingColumnDefinition(filter.column, columns);
        if (!column) {
            return [
                {
                    code: "unsupported_column",
                    message: `Filter column "${filter.column}" is not supported for target "${params.targetObject}".`,
                    index,
                    column: filter.column,
                    filterType: filter.type,
                },
            ];
        }
        if (filter.type === "null") {
            return [];
        }
        const compatibleFilterTypes = filterTypeCompatibility_1.COMPATIBLE_FILTER_TYPES[column.type];
        if (compatibleFilterTypes &&
            compatibleFilterTypes.includes(filter.type)) {
            return [];
        }
        return [
            {
                code: "incompatible_filter_type",
                message: `Filter type "${filter.type}" is not supported for column "${column.name}".`,
                index,
                column: filter.column,
                filterType: filter.type,
                expectedColumnType: column.type,
            },
        ];
    });
    return {
        isValid: issues.length === 0,
        validatedFilters: filters,
        issues,
    };
}
